import React from 'react'
import Header from '../component/Header'
import Donate from '../component/Donate'
import BottomBar from '../component/BottomBar'
import health from '../img/childh.avif'
import feed from '../img/food.avif'
import shelter from '../img/minsh.jpg'
import edu from '../img/childrenschool.avif'
import { Helmet } from 'react-helmet-async'

function OurWork() {

    const data =[
        {
            title: 'Health',
            image: health,
        },
        {
            title: 'Feeding',
            image: feed,
        },
        {
            title: 'Shelter',
            image: shelter,
        },
        {
            title: 'Education',
            image: edu,
        },
    ]

  return (
    <>
        <Helmet>
            <title>Our Work | The Lord Nations Foundation</title>
            <meta name="description" content="Learn about the impactful work of The Lord Nations Foundation. Discover our programs, initiatives, and efforts to create lasting change in communities worldwide." />
        </Helmet>

        <div className='home' >
            <Header/>
            <div className='about_head_spacer'></div>
            <div className='ourwork_banner' >
                <div className='homebanner_overlay'>
                    <div className='homebanner_container'>
                        <div className='homebanner_text' >
                            <div className='donatenow_banner_label' >
                                <h3>OUR WORK</h3>
                            </div>
                        </div>

                        <div className='danate_desk'>
                            <Donate/>
                        </div>
                    </div>
                </div>
            </div>

            <div className='danate_mob'>
            <Donate/>
            </div>

            
            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h1>WE WORK TOGETHER WITH OUR PARTNERS, AND CHILDREN AND THEIR COMMUNITIES, TO TRANSFORM LIVES</h1>
                </div>

                <p>
                    We go to remote corners, villages, and cities where it's really tough to be a child. We ask children, their families, and communities what children need to be healthy, safe, and learning. We listen to their experiences, insights, and ideas. 
                </p>

                <p>
                    Together, we work hand in hand to adapt and create new solutions for children facing crisis, now and in the future.            
                </p>
            </div>


            <div className='our_work_body'>
                {
                    data?.map((inf, i)=>(
                        <div key={i} className='our_work_body_img' style={{backgroundImage:`url(${inf?.image})`, backgroundRepeat:'no-repeat', backgroundSize:'cover', backgroundPosition:'center', position:'relative'}} >
                            <h3>{inf?.title}</h3>
                        </div>
                    ))
                }
            </div>
            
            
            <div className='about_sub' >
                <div className='about_sub_header'>
                    <div className='about_sub_header_line'></div>
                    <h1>A CHILD-RIGHTS APPROACH</h1>
                </div>

                <p>
                    At The Lord Nations Foundation, we have been committed to ensuring all children's rights are recognised. We promote change from the ground up by engaging children, their families and their communities. Together with children, we work with governments and international organisations to ensure children's rights are on the political agenda. We hold leaders to account for the commitments they have made, ensuring systems are in place to protect and provide for all children. 
                </p>
            </div>
            
            <BottomBar/>
        </div>
    </>
  )
}

export default OurWork